module.exports = __webpack_public_path__ + "img/ico_list_close.da05b64e.svg";